import { type DepositProduct } from '@/types/consumer-deposit-application-service';

/**
 * The configuration rule to send when initiating an application. Uses the rule
 * selected by the user (e.g. a fixed term), otherwise the product's only rule.
 */
export const getConfigurationRuleId = (
  product: DepositProduct,
  selectedRuleId?: string | null,
): string | undefined => {
  const rules = product.configurationRules ?? [];

  if (selectedRuleId && rules.some((rule) => rule.id === selectedRuleId))
    return selectedRuleId;

  return rules.length === 1 ? rules[0].id : undefined;
};
